// Import react.
import * as React from 'react';
// Import dispatch hook.
import { useSelector as useSelectorRedux } from 'react-redux';
// Import states.
import {
	AppState
} from '@app/redux/states';

type TSelectorFactoryMethodWithParameters<TReturnData, TParams extends any[], TState extends AppState = AppState> = () => (state: TState, ...params: TParams) => TReturnData;

const useSelector = <TReturnData, TParams extends any[], TState extends AppState = AppState>(selectorFactoryMethod: TSelectorFactoryMethodWithParameters<TReturnData, TParams, TState>, ...params: TParams): TReturnData => {
	const selectorMethod = React.useMemo(() => selectorFactoryMethod(), []);
	return useSelectorRedux<TState, TReturnData>((state: TState) => selectorMethod(state, ...params));
}

export default useSelector;
